export const normalizeApiError = (error) => {
  const message =
    error?.response?.data?.error ||
    error?.response?.data?.message ||
    error?.message ||
    "Ocorreu um erro inesperado.";

  return {
    ...error,
    message,
    response: error?.response,
  };
};
